import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class DashboardApi {
    static async getDashboard() {
        return instance.get('/dashboard');
    }

    static async getProductsDashboard() {
        return instance.get('/products/dashboard')
    }
    static async getDashboardProduct() {
        return instance.get('/product_dashboard')
    }
    static async getDashboardCustomer() {
        return instance.get('/customer_dashboard')
    }
}



// WEBPACK FOOTER //
// ./src/api/dashboard_api.js